import { createStore } from "@xstate/store";

export const floatingPromptStore = createStore({
  context: {
    open: false,
    selectedTaskId: null as string | null,
  },
  on: {
    "prompt.open": (ctx, e: { taskId: string | null }) => ({
      open: true,
      selectedTaskId: e.taskId ?? ctx.selectedTaskId,
    }),
    "prompt.close": () => ({
      open: false,
      selectedTaskId: null as string | null,
    }),
    "prompt.toggle": (ctx) => ({
      open: !ctx.open,
      selectedTaskId: ctx.open ? (null as string | null) : ctx.selectedTaskId,
    }),
    "prompt.selectTask": (ctx, e: { taskId: string }) => ({
      open: ctx.open,
      selectedTaskId: e.taskId,
    }),
  },
});
